import React, { useEffect, useRef, useState } from "react";
import "./ExpertiseSection.css";
import story12 from "./media/prime15.jpeg";

function Counter({ end, suffix = "", duration = 1500, active }) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!active) return; // don’t animate until active

    let frameId;
    const startTime = performance.now();

    const animate = (time) => {
      const progress = Math.min((time - startTime) / duration, 1); // 0 → 1
      const current = Math.floor(progress * end);
      setValue(current);

      if (progress < 1) {
        frameId = requestAnimationFrame(animate);
      }
    };

    frameId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(frameId);
  }, [active, end, duration]);

  return (
    <>
      {value}
      {suffix}
    </>
  );
}

export default function ExpertiseSection() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);

  // Trigger once when section enters viewport
  useEffect(() => {
    const element = sectionRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect(); // run only once
        }
      },
      {
        threshold: 0.4, // 40% of section visible
      }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="expert-section" ref={sectionRef}>
      {/* LEFT SIDE */}
      <div className="expert-left">
        <h2>Leading Expertise</h2>
        <p>
          With years of clinical experience, advanced technology, and a
          patient-first approach, we deliver world-class dental treatments
          with exceptional precision and care.
        </p>
      </div>

      {/* CENTER IMAGE / VIDEO */}
      <div className="expert-center">
        <img
          src={story12}
          alt="Dental expertise"
          className="expert-media"
        />
      </div>

      {/* RIGHT SIDE STATS */}
      <div className="expert-right">
        <h3 className="stat-title">Some Figures</h3>

        <div className="stat-block">
          <h1>
            +
            <Counter end={40} suffix="K" active={inView} />
          </h1>
          <span>Happy Patients</span>
        </div>

        <div className="divider"></div>

        <div className="stat-block">
          <h1>
            +
            <Counter end={41} suffix="K" active={inView} />
          </h1>
          <span>Treatments Completed</span>
        </div>

        <div className="divider"></div>

        <div className="stat-block">
          <h1>
            +
            <Counter end={98} suffix="%" active={inView} />
          </h1>
          <span>Satisfaction Rate</span>
        </div>
      </div>
    </section>
  );
}
